import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'izy-download-confirmation-dialog',
  imports: [
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    // MatDialogClose,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './download-confirmation-dialog.component.html',
  styleUrl: './download-confirmation-dialog.component.scss',
})
export class DownloadConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DownloadConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      documentType: string;
      invoiceId: number;
      invoiceName: string;
      companyName: string;
      text: string;
    }
  ) {
    /* La superficie del dialog e' un ANTENATO di questo componente (vive
       nell'overlay CDK), quindi il suo contorno e la fascia panna delle azioni
       non sono raggiungibili da uno stile incapsulato: servono le regole
       globali di .izy-info-dialog-panel, la veste neutra dei dialog che
       informano senza distruggere niente - la stessa dei tre dialog che
       possono seguire questo (termini, indirizzo email, attesa), cosi' il
       percorso dalla creazione all'invio si legge come una sequenza sola.
       La classe la aggiunge il componente e non il chiamante perche' i punti
       di apertura sono cinque (nuova fattura, dettaglio fattura, bozze,
       fattura veloce, nuovo preventivo) e la veste e' la stessa per tutti. */
    this.dialogRef.addPanelClass('izy-info-dialog-panel');
  }

  downloadPdf(): void {
    this.dialogRef.close({ download: true });
  }

  sendEmail(): void {
    this.dialogRef.close({ sendEmail: true });
  }

  closeDialog(): void {
    this.dialogRef.close({ download: false });
  }
}
